import { render, staticRenderFns } from "./BalancoExportador.vue?vue&type=template&id=467e8015"
import script from "./BalancoExportador.vue?vue&type=script&lang=js"
export * from "./BalancoExportador.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports